<template>
    <div class="notification-wrapper" :class="{ 'notification-page-wrapper': page }" ref="wrapper">
        <button v-if="!page" class="notification-button" type="button" aria-controls="notifications-dropdown" :aria-expanded="isVisible" :aria-label="$t('notifications.general.title')" @click="handleClick">
            <i class="bi bi-bell-fill" aria-hidden="true"></i>
            <span v-if="hasUnreadNotifications" class="unread-indicator bg-danger" aria-hidden="true"></span>
        </button>
        <div v-show="page || isVisible" id="notifications-dropdown" class="notification-dropdown" :class="{ 'notification-page-dropdown': page }" role="region" :aria-hidden="!page && !isVisible" :aria-label="$t('notifications.general.title')">
            <div class="header">
                <h5 class="mb-0"> {{ $t('notifications.general.title') }} </h5>
                <div class="filter-controls">
                    <span>{{ $t('notifications.general.all') }}</span>
                    <label class="switch">
                        <input id="show-unread-notifications" type="checkbox" v-model="showUnreadOnly">
                        <span class="slider round"></span>
                    </label>
                    <label for="show-unread-notifications">{{ $t('notifications.general.unread') }}</label>
                </div>
            </div>
            <div v-if="filteredNotifications.length > 0" class="scrollable-content">
            <div v-for="notification in filteredNotifications" :key="notification.id">
                <a v-if="isExternalLink(notification.notificationData?.link)"
                    :href="notification.notificationData.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click="handleClick"
                    class="black-to-blue-link">
                    <div @mouseover="markAsRead(notification)" class="rounded notification-instance">
                    <h5>{{ notification.title }}</h5>
                    <p class="to-blur" :class="{ blurred: isBlurred, 'd-flex justify-content-between': notification.notificationData?.link }">{{ notification.text }}<span v-if="notification.notificationData?.link"><i class="bi bi-link-45deg"></i></span></p>
                    <span v-if="notification.status == 0" class="unread-indicator-instance bg-danger"></span>
                    <p class="notification-date">{{ notification.created }}</p>
                    </div>
                </a>

                <!-- Internal link -->
                <router-link v-else-if="notification.notificationData?.link" :to="notification.notificationData.link" @click="handleClick" class="black-to-blue-link">
                    <div @mouseover="markAsRead(notification)" class="rounded notification-instance">
                    <h5>{{ notification.title }}</h5>
                    <p class="to-blur" :class="{ blurred: isBlurred, 'd-flex justify-content-between': notification.notificationData?.link }">{{ notification.text }}<span v-if="notification.notificationData?.link"><i class="bi bi-link-45deg"></i></span></p>
                    <span v-if="notification.status == 0" class="unread-indicator-instance bg-danger"></span>
                    <p class="notification-date">{{ notification.created }}</p>
                    </div>
                </router-link>

                <div v-else @mouseover="markAsRead(notification)" class="rounded notification-instance black-to-blue-link disabled-link"                 >
                    <h5>{{ notification.title }}</h5>
                    <p class="to-blur" :class="{ blurred: isBlurred }">{{ notification.text }}</p>
                    <span v-if="notification.status == 0" class="unread-indicator-instance bg-danger"></span>
                    <p class="notification-date">{{ notification.created }}</p>
                </div>
            </div>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
                <p>{{ $t('notifications.general.empty') }}</p>
            </div>
            <router-link v-if="!page" to="/notifications" class="notification-view-all" @click="handleClick">
                {{ $t('notifications.general.view-all') }}
            </router-link>
        </div>
    </div>

    <SystemNotificationModal ref="systemNotificationModal" @readed="handleReaded" @closed="handleModalClose" />
</template>

<script>
import SystemNotificationModal from './SystemNotificationModal.vue'

export default {
    data: () => ({
        isVisible: false,
        showUnreadOnly: false,
        notifications: [],
        announcements: [],
        filteredNotifications: []
    }),
    name: 'SystemNotifications',
    props: {
        page: {
            type: Boolean,
            default: false
        }
    },
    components: { SystemNotificationModal },
    watch: {
            notifications: {
                immediate: true,
                handler() {
                    this.filteredNotifications = this.showUnreadOnly ? this.notifications.filter(notification => notification.status == 0) : this.notifications
                }
            },
            showUnreadOnly: {
                immediate: true,
                handler() {
                    this.filteredNotifications = this.showUnreadOnly ? this.notifications.filter(notification => notification.status == 0) : this.notifications
                }
            }
    },
    computed: {
        hasUnreadNotifications() {
            return this.notifications.some(notification => notification.status == 0)
        },
        notificationText() {
            return {
                newClaimInbox: (slug) => this.$t('notifications.text.new-claim-inbox', { slug }),
                claimStatusChanged: (slug, status) => this.$t('notifications.text.claim-status-changed', { slug, status }),
                other: () => this.$t('notifications.text.default')
            }
        },
        notificationTitle() {
            return {
                newClaimInbox: () => this.$t('notifications.title.new-claim-inbox'),
                claimStatusChanged: () => this.$t('notifications.title.claim-status-changed'),
                other: () => this.$t('notifications.title.default')
            }
        },
        isBlurred: {
            get() {
                return this.$store.getters.getBlur == true
            },
            set(value) {
                this.$store.commit('setBlur', value)
            },
        },
    },
    methods: {
        isExternalLink(link) {
            return /^https?:\/\//.test(link || '')
        },
        syncBlurState(event) {
            if (event.key === 'isBlurred') {
                this.isBlurred = event.newValue === 'true';
            }
        },
        handleClick() {
            this.isVisible = !this.isVisible
        },
        handleClickOutside(event) {
            if (this.$refs.wrapper && !this.$refs.wrapper.contains(event.target)) {
                this.isVisible = false
            }
        },
        markAsRead(notification) {
            let url = process.env.VUE_APP_API_URL + '/system-notifications/read'

            axios.post(url, {
                id: notification.id
            },{
                withCredentials: true
            })
            .then((response) => {
                if(process.env.VUE_APP_DEBUG) console.log(response)

                let r = response.data

                if(r.result === 'SUCCESS') {
                    notification.status = 1
                } 
            })
            
        },
        setNotificationTitle(notification) {
            if (notification.event === 'newClaimInbox') {
                notification.title = this.notificationTitle[notification.event]()
            } else if (notification.event === 'claimStatusChanged') {
                notification.title = this.notificationTitle[notification.event]()
            } else if (notification.event === 'other') {
                notification.title = this.notificationTitle[notification.event]()
            } else if (notification.event === 'custom') {
                notification.title = notification.notificationData.title
            } else {
                notification.title = this.$t('notifications.title.default')
            }
        },
        setNotificationText(notification) {
            const slug = notification.notificationData.slug
            const statusKey = notification.notificationData.status
            const status = this.$t(`claim.statuses.${statusKey}`)

            if (notification.event === 'newClaimInbox') {
                notification.text = this.notificationText[notification.event](slug)
            } else if (notification.event === 'claimStatusChanged') {
                notification.text = this.notificationText[notification.event](slug, status)
            } else if (notification.event === 'custom') {
                notification.text = notification.notificationData.message
            } else if (notification.event === 'other') {
                notification.text = this.notificationText[notification.event]()
            } else {
                notification.text = this.$t('notifications.text.default')
            }
        },
        getNotifications() {
            let url = process.env.VUE_APP_API_URL + '/system-notifications/get-notifications'

            axios.get(url, { withCredentials: true })
            .then((response) => {
                if(process.env.VUE_APP_DEBUG) console.log(response)

                let r = response.data

                if(r.result === 'SUCCESS' && r.data != []) {
                    this.notifications = r.data
                    this.notifications.forEach(notification => {
                        this.setNotificationText(notification)
                        this.setNotificationTitle(notification)
                    })
                } 
            })
        },
        handleReaded(data) {
            this.markAsRead(data)
        },
        async handleModalClose(data) {
            await this.markAsRead(data)
            await this.getAnnouncement()
        },
        async getAnnouncement() {
            let r = await this.$api.getAnnouncement()

            if(r.result == 'SUCCESS') {
                this.announcements = r.data
                this.announcements.forEach(announcement => {
                    this.setNotificationText(announcement)
                    this.setNotificationTitle(announcement)
                })

                this.showAnnouncement()
            }
        },
        showAnnouncement() {
            if(this.announcements.length > 0) {
                this.$refs.systemNotificationModal.set(this.announcements.shift())
                this.$refs.systemNotificationModal.show()
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
        this.getNotifications()
        this.getAnnouncement()
        window.addEventListener('storage', this.syncBlurState)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
        window.removeEventListener('storage', this.syncBlurState)
    }
}
</script>

<style scoped>

.black-to-blue-link {
    color: var(--kdp-text-main);
    text-decoration: none; 
}

.filter-controls {
    display: flex;
    align-items: center;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    background-color: var(--kdp-surface-card-alt);
    z-index: 1;
    padding: var(--kdp-space-5) 20px 20px 30px;
    border-bottom: 1px solid var(--kdp-border-default);
}

.label {
    margin: 0 5px;
}

.notification-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 24px;
    color: var(--kdp-primary-link);
    font-size: 20px; 
    position: relative;
    padding: 5px;
}

.notification-button:hover {
    color: var(--kdp-primary-link);
}

.notification-date {
    font-size: 0.8rem;
    color: var(--kdp-text-muted);
    margin-bottom: 0;
}

.notification-dropdown {
    position: absolute;
    top: 100%; 
    right: 0;
    background-color: var(--kdp-dropdown-bg);
    border: 1px solid var(--kdp-border-default);
    box-shadow: 0 4px 8px var(--kdp-shadow-color);
    z-index: 1000; 
    max-height: 80vh;
    width: 500px;
    display: flex;
    flex-direction: column;
}

.notification-view-all {
    display: block;
    padding: .75rem 1rem;
    color: var(--kdp-primary-link);
    text-align: center;
    text-decoration: none;
    border-top: 1px solid var(--kdp-border-default);
}

.notification-view-all:hover,
.notification-view-all:focus-visible {
    color: var(--kdp-primary-dark);
    background-color: var(--kdp-dropdown-hover);
}

.notification-page-wrapper {
    width: 100%;
}

.notification-page-dropdown {
    position: static;
    width: 100%;
    max-height: none;
    border: 1px solid var(--kdp-border-default);
    box-shadow: var(--kdp-shadow-card);
}

@media (max-width: 576px) {
    .notification-page-dropdown .header {
        flex-wrap: wrap;
        gap: .65rem;
        padding: 1rem;
    }

    .notification-page-dropdown .header h5 {
        flex: 0 0 100%;
    }

    .notification-page-dropdown .filter-controls {
        font-size: .85rem;
    }
}

.notification-instance {
    position: relative;
    padding: 0px 30px 0px 30px !important;
}

.notification-instance:first-child {
    margin-top: 0 !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}


.notification-instance:hover {
    background-color: var(--kdp-dropdown-hover);
}

.notification-wrapper {
    position: relative;
    display: inline-block;
}

.p-3 {
    padding: 0.5rem 1rem !important;
}

.scrollable-content {
    overflow-y: auto;
    flex-grow: 1;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

.switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 20px;
    margin: 0 5px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.unread-indicator {
    position: absolute;
    top: 10px;
    right: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.unread-indicator-instance {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
}

input:checked + .slider {
    background-color: var(--kdp-primary-deep);
}

input:checked + .slider:before {
    transform: translateX(14px);
}

</style>
